import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The standard shadcn `cn` helper: `clsx` for conditional class composition,
 * `twMerge` to resolve conflicting Tailwind utility classes (e.g. a caller
 * overriding a primitive's default `text-sm` with `text-lg`) in favor of the
 * last one. Used exclusively by `components/ui/*` primitives (plan 188
 * W2-M8, task 799) — existing `components/primitives/*` components keep
 * their plain string-join convention untouched.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
